import React, { useState, useEffect } from "react";
import { Grid, Stack, Box, Button } from "@mui/material";
import { useHistory } from "react-router-dom";
import eye from "../../../assets/images/Blog/BD/a;hi.png";
import comment from "../../../assets/images/Blog/BD/agrg.png";
import share from "../../../assets/images/Blog/BD/agr.png";
import hands from "../../../assets/images/Blog/BD/Group 63.png";
import DeleteIcon from '@mui/icons-material/Delete';
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import { deletePost, getUserPosts, setOpenedPost, setUserDraftPostEdit } from "../../../store/actions/posts";
import BlogEditorStyles from "../BlogEditorStyles";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import './Blog.css'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { useFirestoreConnect } from "react-redux-firebase";
import logoImages from "../../../assets/images/logo1.png";

export default function AppDraftData(props) {
  const classes = BlogEditorStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { userDraftPosts } = useSelector((state) => state.posts)
  const auth = useSelector(state => state.firebase.auth);
  const [id, setId] = useState([]);

  const [user, setUser] = useState([]);
  const { firestore } = useSelector((state) => state);
  const { users } = firestore.ordered;
  useFirestoreConnect([{ collection: "users", doc: auth.uid }]);
  useEffect(() => {
    if (users) {
      const currentUser = users[0];
      setUser({ ...user, ...currentUser });
    }
  }, [users]);

  useEffect(() => {
    try {
      dispatch(getUserPosts())
    } catch (error) {

    }
  }, []);

  const onClickDraft = (post) => {

    dispatch(setUserDraftPostEdit(true))
    dispatch(setOpenedPost(post))
    history.push('/blog-editor')
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (post) => {
    setId(post.id);
    setOpen(true);
  };
  const handleClose = (id) => {
    dispatch(deletePost(id));
    dispatch(getUserPosts())
    setOpen(false);
  }
  const notDelete = () => {
    setOpen(false);
  }
  return (
    <Grid container spacing={2}>
      <Dialog
        open={open}
        keepMounted
        onClose={notDelete}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{'Are you sure you want to Delete ?'}</DialogTitle>
        <DialogContent>
        </DialogContent>
        <DialogActions>
          <Button style={{ background: 'rgb(0, 31, 88)', color: '#fff' }} onClick={() => handleClose(id)}>Yes</Button>
          <Button style={{ background: 'rgb(0, 31, 88)', color: "#fff" }} onClick={() => notDelete(id)}>No</Button>
        </DialogActions>
      </Dialog>

      {userDraftPosts && userDraftPosts.length > 0
        ? userDraftPosts.map((post, index) => (
          <Grid item xs={12} sm={4} md={4} lg={4} style={{ cursor: 'pointer' }}>
            <Stack className={classes.responsiveCard}>
              <Grid container spacing={1} direction="column">
                <Grid item>
                  <Box style={{ position: "relative" }}>
                    <Box style={{ display: 'flex' }}>
                      <DeleteIcon onClick={() => handleClickOpen(post)} className={classes.deltDraftStyles} />
                      <ModeEditIcon onClick={() => onClickDraft(post)} className={classes.editDraftStyles} />
                    </Box>
                    <div style={{
                      minHeight: '200px', backgroundColor: 'skyblue', display: 'flex',
                      justifyContent: 'center', alignItems: 'center'
                    }}>
                      {
                        post.images && post.images.length > 0 ?
                          <img
                            src={post.images[0]}
                            //  src={bgImageSrc2}
                            alt="bg" style={{ width: "100%", height: '200px', objectFit: 'cover' }} />
                          :
                          <img
                            src={logoImages}
                            //  src={bgImageSrc2}
                            alt="bg" style={{ width: "50%", height: 'auto', margin: 'auto' }} />

                      }
                    </div>

                    <Box
                      style={{
                        position: "absolute",
                        bottom: "0",
                        // margin: "10px",
                        padding: '10px',
                        width: '78vw',
                        // background: 'linear-gradient(rgba(255,0,0,0), #878383)',
                        background: 'linear-gradient(rgba(255,0,0,0), #000000)',


                      }}
                    >
                      <Grid
                        container
                        direction="row"
                        spacing={4}
                        style={{ color: "#fff" }}
                      >
                        <Grid item>
                          <img src={eye} alt="" />
                          <span>
                            {post?.views || 0}
                          </span>
                        </Grid>
                        <Grid item>
                          <img src={hands} alt="" />
                          <span>
                            {post && post.likedby
                              ? post?.likedby?.length
                              : 0}
                          </span>
                        </Grid>
                        <Grid item>
                          <img src={comment} alt="" />
                          <span>
                            {post?.commentscount || 0}
                          </span>
                        </Grid>
                        <Grid item>
                          <img src={share} alt="" />
                          <span>
                            {post?.shared || 0}
                          </span>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
                <Grid item>
                  <Stack
                    direction="column"
                    spacing={2}
                    style={{
                      padding: "1rem",
                    }}
                  >
                    <div style={{ height: '100px', overflow: 'hidden' }}>
                      <h3 style={{
                        color: "grey", marginTop: "0px", cursor: "pointer",
                      }} >
                        {/* Lorem ipsum dolor */}
                        {post?.title}
                      </h3>

                      <p
                        style={{
                          marginTop: "5px",
                          fontSize: "small",
                          color: "grey",
                          whiteSpace: 'nowrap !important',
                          overflow: 'hidden !important',
                          textOverflow: 'ellipsis !important',
                          width: '100%'
                        }}
                        className='paragraphHtml'
                      >
                        {
                          post && post.body ? ReactHtmlParser(post?.body) : null
                        }

                        {/* {
                          post.body ?
                            post.body.length < 100 ?
                              ReactHtmlParser(post?.body) :
                              ReactHtmlParser(post?.body.substring(0, 50)) + '....' : ''
                        } */}
                      </p>
                    </div>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      marginBottom="0"
                    >
                      <Grid item xs={12} sm={6} md={6} lg={2}>
                        <img
                          // src={blog?.image} 
                          style={{
                            width: "34px",
                            height: "34px",
                            borderRadius: "50%",
                          }}
                          src={auth?.photoURL || auth?.avatarURL}
                          alt="pi" />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={7}>
                        <Stack direction="row" spacing={2}>
                          <b
                            style={{
                              fontWeight: "500",
                              color: "rgb(0, 31, 88)",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {
                              auth && auth.displayName ?
                                auth?.displayName?.slice(0, 11) + '...' :
                                user?.displayName?.slice(0, 11) + '...'
                            }
                          </b>
                          {/* <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis', }}>{post?.blogId?.label}</span> */}
                        </Stack>
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <b
                          style={{
                            fontWeight: "500",
                            color: "rgb(0, 31, 88)",
                            textAlign: "right",
                            overflow: 'hidden'
                          }}
                        >
                          {post.lastUpdate
                            ? moment
                              .unix(post?.lastUpdate?.seconds)
                              .format("DD MMM YY")
                            : null}
                        </b>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>

            </Stack>
          </Grid>
        ))
        : null}
    </Grid>
  );
}
